// import storage from 'store'
import Cookies from "js-cookie"
import { login, getInfo, logout, getAdminToken } from '@/api/login'
import { clearMomBootstrap, setMomBootstrapUserInfo } from '@/utils/mom-bootstrap'
// import { ACCESS_TOKEN } from '@/store/mutation-types'
import { welcome } from '@/utils/util'

const user = {
  state: {
    userId: 0,
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    roles: [],
    info: {},
    email: '',
    phonenumber: '',
    sex: 0,
    permissions: [],
    sysMenus: [],
    inventOrg: [],
    jobCode: "",
    organizationCode: ""
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      localStorage.setItem('token', token)
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_SEX: (state, sex) => {
      state.sex = sex
    },
    SET_EMAIL: (state, email) => {
      state.email = email
    },
    SET_PHONE: (state, phonenumber) => {
      state.phonenumber = phonenumber
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId
    },
    SET_PERMISSION: (state, permissions) => {
      state.permissions = permissions
    },
    SET_SYSMENUS: (state, sysMenus) => {
      state.sysMenus = sysMenus
    },
    SET_INVENTORG: (state, inventOrg) => {
      state.inventOrg = inventOrg
    },
    SET_JOB_CODE: (state, jobCode) => {
      state.jobCode = jobCode
    },
    SET_ORGANIZATIONCODE: (state, organizationCode) => {
      state.organizationCode = organizationCode
    }
  },

  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          // 保证登录成功以后才来获取token
          if (response.code === 200) {
            const result = response.data
            localStorage.setItem('token', result.access_token)
          }
          // storage.set(ACCESS_TOKEN, result.access_token, 7 * 24 * 60 * 60 * 1000)
          // localStorage.setItem('token', result.access_token)
          // commit('SET_TOKEN', result.access_token)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo ({ commit }) {
      const CookiesObj = Cookies;
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const result = response.data
          if (result) {
            setMomBootstrapUserInfo(result)
            const user = result.user
            const avatar = user.avatar
            if (result.roles && result.roles.length > 0) { // 验证返回的roles是否是一个非空数组
              commit('SET_ROLES', result.roles)
            } else {
              commit('SET_ROLES', ['ROLE_DEFAULT'])
            }
            commit('SET_PERMISSION', result.componentList)
            commit('SET_SYSMENUS', result.sysMenus)
            commit('SET_INVENTORG', result.inventOrg)
            // commit('SET_NAME', user.nickName)
            commit('SET_NAME', { name: user.nickName, welcome: welcome() })
            commit('SET_AVATAR', avatar)
            commit('SET_SEX', user.sex)
            commit('SET_EMAIL', user.email)
            commit('SET_PHONE', user.phonenumber)
            commit('SET_USER_ID', user.userId)
            commit('SET_JOB_CODE', user.jobCode)
            if (user.jobCode) {
              CookiesObj.set('jobNo', user.jobCode, { expires: new Date().setFullYear(new Date().getFullYear() + 1) })
            }
            resolve(response)
          }
          // GetInfo一旦失败就说明这个token不是过期就是丢失了,直接走catch并让调用方跳转路由
          if (result.code === 500) {
            reject(result)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetAdminToken ({ commit }) {
      return new Promise((resolve, reject) => {
        // 非OA门户登录或已有Admin-Token，直接返回，无需获取
        if (Cookies.get('Admin-Token') || localStorage.getItem('isFromSystemLogin') === 'true') {
          resolve();
          return;
        }
        // TODO localStorage的token本地运行的时候会是auth的token，但非本地会是oa的token，因此逻辑有点混乱
        const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get(process.env.VUE_APP_XSRF_NAME);
        getAdminToken(token).then(() => {
          if (Cookies.get('Admin-Token')) {
            resolve();
          } else {
            reject(new Error('获取Admin-Token失败'));
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    Logout ({ commit }) {
      return new Promise((resolve, reject) => {
        logout().then(response => {
          if (response.code === 200) {
            clearMomBootstrap()
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            commit('SET_PERMISSION', [])
            commit('SET_SYSMENUS', [])
            commit('SET_INVENTORG', [])
            // storage.remove(ACCESS_TOKEN)
            const whitelist = ['intro', 'isFromSystemLogin'];
            const len = localStorage.length;
            for (let i = 0; i < len; i++) {
              // 获取key 索引从0开始
              const getKey = localStorage.key(i);
              if (whitelist.indexOf(getKey) === -1) {
                localStorage.removeItem(getKey);
              }
            }
            sessionStorage.clear();
            Cookies.remove(process.env.VUE_APP_XSRF_NAME, { domain: 'linshimuye.com' });
            for (const key in Cookies.get()) {
              Cookies.remove(key);
            }
            console.log('到这里了')
            resolve(true)
          }
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // 页面右上角的组织
    SetOrganizationCode ({ commit }, val) {
      commit('SET_ORGANIZATIONCODE', val)
    }
  }
}

export default user
